import {Injectable} from '@angular/core';
import {MissingTranslationHandler, MissingTranslationHandlerParams} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class NotTranslatedService {
  notTranslated(key: any) {
    // console.log('Not translated ', key);
  }
}

@Injectable()
export class CoreMissingTranslationHandler implements MissingTranslationHandler {
  missingKeysList = [];
  missingKeysListUniqueValues = [];

  handle(params: MissingTranslationHandlerParams) {
    // this.missingKeysList.push(params.key);
    // this.missingKeysListUniqueValues = this.missingKeysList.filter( function( item, index, inputArray ) {
    //   return inputArray.indexOf(item) == index;
    // });
    // this.nts.notTranslated(this.missingKeysListUniqueValues);
    return  params.key;
  }

  constructor(
    private nts: NotTranslatedService
  ) {
  }
}
